<template>
  <section>
    <!-- <header class="mui-bar mui-bar-nav">
      <a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>
      <h1 class="mui-title">质检标签</h1>
    </header> -->
    <div class="mui-content">
      <div class="title-name">
        <span class="">质检标签</span>
      </div>
      <div style="margin-top: 25px;">
        <div class="form-group">
          <div class="input-label">
            <label>当前供应商:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="ksmc" readonly>
          </div>
        </div>
      </div>
      <div>
        <div class="sampling-first-title">
          <h4 style="padding-left: 15px;">基础信息</h4>
        </div>
        <!--第一行-->
        <div class="form-group">
          <div class="input-label">
            <label>物料:</label>
          </div>
          <div class="form-input">
            <div style="width: 85%;margin-bottom: 15px;">
               <multiselect v-model="wphinfo" :options="scxtwpLst" :close-on-select="true" placeholder="请输入物料"  label="dipname" track-by="scxtwph" @select="wphSelected" :multiple="false" :showLabels = "false" :allowEmpty="false"></multiselect>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label"></label>
          <div class="form-input" style="padding-top: 0px;display: flex;display: inline-flex;">
            <div class="width: 100%;margin-bottom: 0px;">
              <div class="mui-input-row mui-checkbox mui-left">
                <input type="checkbox" v-model="notFilledUpFlg" value="true" id="filledCheckbox"  style="left:0;" @change="changeOrder">
                <label style="font-size: 14px;padding-left:25px;" for="filledCheckbox" >仅显示未录满订单</label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>外注订单:</label>
          </div>
          <div class="form-input">
            <select v-model="orderinfo" @change="getNoLst">
              <option v-for="(item,idx) in orderLst" :key="idx" :value="item">{{item.ddh}}</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="isTSD&&(ddqf=='1')">
          <div class="input-label">
            <label>出库单号:</label>
          </div>
          <div class="form-input">
            <select v-model="shipmentnoinfo">
              <option v-for="(item,idx) in ckdLst" :key="idx" :value="item">{{item.shipmentno}}</option>
            </select>
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="add" v-if="!isTSD" :disabled="(ddqf=='3' && zjlrzt=='01')">卷添加</button>
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="ybjl" v-if="!isTSD && (ddqf=='2') && (orderinfo && orderinfo.inspectflag=='0')">验布记录</button>
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="getList">已检查询</button>
          <button type="button" class="mui-btn mui-btn-default btn-blue" style="margin: auto;min-width: 80px;" v-if="(isTSD&&((ddqf=='1')&&(randomcheckflag=='0')))" @tap="Cj">抽检</button>

        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
Vue.component('multiselect', Multiselect)
export default {
  name: "quality",
  components: { Multiselect },
  data() {
    return {
      ksbh: "",
      ksmc: "",
      orderLst: [],
      ddh: "",
      scxtwpLst: [],
      wphinfo: null,
      wph: "",
      ddqf: "",
      ckdLst: [],
      shipmentnoinfo: null,
      isTSD: false,
      orderinfo:null,
      randomcheckflag:"",// 0：抽检 1：不抽检
      zjlrzt:"",// 质检截止 00：正常 01：截止
      notFilledUpFlg: false // 仅显示未录满订单
    }
  },
  created() {
    var v = this;
    v.getKsbh();
    v.nyy.wxInit();
  },
  activated() {},
  methods: {
    scanQRCode(callback){
      var v = this;
      // 需校验当前扫码是否是该出库单号下指示的明细
      wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            if(callback)callback(rollstr);
          }
        },
        error: function(res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    // 当前供应商
    getKsbh() {
      var v = this;
      v.nyy.doPost("/Quality/getKsbh", {},
        function(result) {
          if (result.status) {
            v.ksbh = result.data.ksbh;
            v.ksmc = result.data.ksmc;
            v.isTSD = result.data.isTSD;
            v.getScxtwpLst();
          }
        }
      );
    },
    // 选中事件
    wphSelected(selectedOption,id) {
      var v = this;//{{item.scxtwph}} {{item.scxtwpmc}}
      v.wphinfo = selectedOption;

      v.wph = v.wphinfo ? v.wphinfo.wph : "";
      v.nyy.doPost("/Quality/getOrderLstWithCondition", { ksbh: v.ksbh, wph:v.wph, notFilledUpFlg:v.notFilledUpFlg ? "1" : "0" },
        function(result) {
          if (result.status) {
            v.orderLst = result.data.infoLst;
            v.orderinfo = null;
            v.shipmentnoinfo = null;
            if(v.orderLst && v.orderLst.length>0){
              v.orderinfo = v.orderLst[0];
              v.getNoLst();
            }else{
              v.ddh = "";
              v.zjlrzt = "";
            }
          }
        }
      );
    },
    changeOrder(){// 仅显示未录满订单 change事件
      var v = this;
      debugger
      v.getOrderLst();
    },
    // 外注订单
    getOrderLst() {
      var v = this;
      v.wph = v.wphinfo ? v.wphinfo.wph : "";
      v.nyy.doPost("/Quality/getOrderLstWithCondition", { ksbh: v.ksbh, wph:v.wph, notFilledUpFlg:v.notFilledUpFlg ? "1" : "0" },
        function(result) {
          if (result.status) {
            v.orderLst = result.data.infoLst;
            v.orderinfo = null;
            v.shipmentnoinfo = null;
            if(v.orderLst && v.orderLst.length>0){
              v.orderinfo = v.orderLst[0];
              v.getNoLst();
            }
          }
        }
      );
    },
    // 物料
    getScxtwpLst() {
      var v = this;
      v.nyy.doPost("/Quality/getScxtwpLst", {},
        function(result) {
          if (result.status) {
            v.scxtwpLst = result.data.infoLst;
            v.wphinfo = null;
            if(v.scxtwpLst && v.scxtwpLst.length>0){
              v.wphinfo = v.scxtwpLst[0];
              v.getOrderLst();
            }
          }
        }
      );
    },
    // 出库单
    getNoLst() {
      var v = this;
      v.ddh = v.orderinfo.ddh;
      v.randomcheckflag = v.orderinfo.randomcheckflag;
      v.wph = v.orderinfo ? v.orderinfo.wph : "";
      v.ddqf = v.orderinfo ? v.orderinfo.ddqf : "";
      v.zjlrzt= v.orderinfo ? v.orderinfo.zjlrzt: "";
      // 仅当TSD登录时，机织模式下表示
      if (!v.isTSD || (v.ddqf != '1')) {
        return;
      }
      v.nyy.doPost("/Quality/getNoLst", { ddh: v.ddh, wph: v.wph },
        function(result) {
          if (result.status) {
            // 新增空白选项
            var list = result.data.infoLst;
            list.unshift({ "statusflg": "", "shipmentno": "" });
            v.ckdLst = list;
            v.shipmentnoinfo = null;
            if(v.ckdLst && v.ckdLst.length>0){
              v.shipmentnoinfo = v.ckdLst[0];
            }
          }
        }
      );
    },
    getList() {
      var v = this;
      if (!v.check()) {
        return;
      }
      if(v.shipmentnoinfo && (v.shipmentnoinfo.shipmentno!="")){
        v.$router.push({ "name": "qualityListCJ", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "shipmentno": v.shipmentnoinfo.shipmentno }) });
      }else{
        v.$router.push({ "name": "qualityList", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph }) });
      }
      // if (v.isTSD) {
      //   v.$router.push({ "name": "qualityListCJ", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "shipmentno": v.shipmentnoinfo.shipmentno }) });
      // } else {
      //   v.$router.push({ "name": "qualityList", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph }) });
      // }
    },
    add() {
      var v = this;
      if (!v.check()) {
        return;
      }
      v.jtj_check(function(){
          var para_info = {};
          if (v.isTSD) {
            para_info = { "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "shipmentno": v.shipmentnoinfo.shipmentno };
          } else {
            para_info = { "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph };
          }
          if(v.ddqf=='2'){
            if(v.wph.startsWith("0103")){ // 经编
              v.$router.push({ "name": "qualityDetailBZJB", params: para_info });
            }else{
              v.$router.push({ "name": "qualityDetailBZ", params: para_info });
            }  
          }else{
            v.$router.push({ "name": "qualityDetail", params: jsonPara(para_info) });
          }
      });
      
     
    },
    // 验布记录
    ybjl(){
      var v = this;
      if (!v.check()) {
        return;
      }
      v.scanQRCode(function(tsdrollno){
        var para_info = { "ddh": v.ddh, "wph": v.wph,"tsdrollno": tsdrollno };
        v.$router.push({ "name": "qualityDetailYB", params: jsonPara(para_info) });
      });
    },
    check() {
      var v = this;
      if (v.ddh == "") {
        mui.toast("请选择外注订单");
        return false;
      }
      if (v.wph == "") {
        mui.toast("请选择物料");
        return false;
      }
      return true;
    },
    // 抽检
    Cj(){
      var v = this;
      if (!v.check()) {
        return;
      }
      if(v.shipmentnoinfo && (v.shipmentnoinfo.shipmentno!="")){
        v.$router.push({ "name": "qualityDetail", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "shipmentno": v.shipmentnoinfo.shipmentno,"iscj":true }) });
      }else{
        // 不选择出库单号进行抽检

        v.$router.push({ "name": "qualityDetail", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph ,"iscj":true}) });
      }
    },
    // 质检录入追加校验 卷添加时追加校验，校验当前选择的订单号是否可录入数据，若是不可，则不可后续操作
    jtj_check(callback){
       // 1、校验小于当前选择的订单前，是否存在未录入满的订单
       // 2、校验当前选择的订单，对应已录的数量是否超过订单数量上限
      var v = this;
      if(v.ddqf == "3"){
         if(callback) callback();
         return;
      }
      v.nyy.doPost("/Quality/checkOrder", {
        "ddh": v.ddh, 
        "wph": v.wph,
        "orderlist":v.orderLst
      },
      function(result) {
        if (result.status) {
           var rtndata = result.data;
           if(rtndata.ddh_exsitflg){
              mui.toast("请选择交期在此订单前，未录满的订单");
              return;
           }else if(!rtndata.order_normal_flg){
              mui.toast("当前选择的订单已录满。");
              return;
           }else{
              if(callback)callback();
           }
        }
      });
    }
  }
}
</script>
<style src="../../static/css/vue-multiselect.min.css"></style>
<style scoped>
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
.multiselect__input{
   border:none;
}
.multiselect__single{
  white-space: nowrap;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/quality.vue